import { SORT_ORDER } from '../constants';

export const sortChange = ({
  sort, // Sorting function for given module
  sortData, // Raw sorting data coming from Kendo Grid
  gridId, // ID of the current grid
  saveGridSettings, // Function for saving grid settings into the user profile
  defaultSort, // Property for default sorting
}) => {
  if (sortData.length) {
    const sortObject = {
      sortBy: sortData[0].field,
      sortOrder: sortData[0].dir === 'asc' ? SORT_ORDER.ASC : SORT_ORDER.DESC,
    };

    sort(sortObject);
    saveGridSettings({
      id: gridId,
      settings: {
        sort: sortObject,
      },
    });
  } else {
    const sortObject = {
      sortBy: defaultSort || 'id',
      sortOrder: SORT_ORDER.ASC,
    };

    sort(sortObject);
    saveGridSettings({
      id: gridId.RFP,
      settings: {
        sort: sortObject,
      },
    });
  }
};


export const prepareColumnsData = ({
  columns = [],
  initialColumns = [],
  settingsColumns = [],
}) =>
  // Loop through the initial columns collection to preserve original config
  initialColumns.map(initialColumn => {
    // Check if newer settings has been found
    const foundNewColumn = columns.find(
      column => column.field === initialColumn.field && column.width
    );

    // Check if previous settings has been found
    const foundSettingsColumn = settingsColumns.find(
      settingsColumn => settingsColumn.field === initialColumn.field && settingsColumn.width
    );

    return foundNewColumn || foundSettingsColumn || initialColumn;
  });
